import { Loading } from 'components/loading/loading'
import { useAuth } from 'hooks/useAuth'
import useGoogleAnalytics from 'hooks/useGoogleAnalytics'
import { Outlet } from 'react-router-dom'

export const IndexLayout = () => {
  const { appIsHydrated } = useAuth()
  useGoogleAnalytics()

  if (!appIsHydrated) {
    return <Loading withBackgroundColor />
  }

  return <Outlet />
}
